<template>
  <div class="section std d-flex is-flex-direction-column">
    <div class="inner-section gallery">
      <div class="section-container h-100">
        <div class="my-content h-100">
          <h2 class="titolo mobile">{{ trans.get('public.gallery.gallery') }}</h2>
          <div
              class="container h-100 d-flex flex-column justify-content-center"
          >
            <!-- <carousel /> -->

            <h2 class="titolo desktop">{{ trans.get('public.gallery.gallery') }}</h2>
            <div
                v-if="carousel_items"
                id="gallery-carousel"
                class="d-flex flex-nowrap my-slide"
                :style="{ marginLeft: -1 - move + 'vw' }"
            >
              <div
                  class="external"
                  v-for="(item, i) in carousel_items"
                  :key="i"
              >
                <div
                    class="item"
                    :style="{ backgroundImage: 'url(' + item.media_url + ')' }"
                >
                  <!-- <img :src="item.media_url" alt="item.id"> -->
                </div>
              </div>
            </div>
            <div class=" my-controls desktop align-items-center
                justify-content-between mt-3 ">
              <div
                  class="my-prev pointer d-flex align-items-center"
                  @click="prev()">
                <img
                    data-v-4a829784=""
                    src="/media/icons/svg/arrow-left_white.svg"
                    alt=""
                    class="pointer"
                />
                <span>{{ trans.get('public.gallery.previous') }}</span>
              </div>
              <div
                  class="my-next pointer d-flex align-items-center"
                  @click="next()"
              >
                <span>{{ trans.get('public.gallery.next') }}</span>
                <img
                    data-v-4a829784=""
                    src="/media/icons/svg/arrow-right_white.svg"
                    alt=""
                    class="pointer"
                />
              </div>
            </div>
          </div>
          <div class=" my-controls mobile align-items-center
                justify-content-between mt-3 ">
            <div
                class="my-prev pointer d-flex align-items-center"
                @click="prev()">
              <img
                  data-v-4a829784=""
                  src="/media/icons/svg/arrow-left_white.svg"
                  alt=""
                  class="pointer"
              />
              <span>{{ trans.get('public.gallery.previous') }}</span>
            </div>
            <div
                class="my-next pointer d-flex align-items-center"
                @click="next()"
            >
              <span>{{ trans.get('public.gallery.next') }}</span>
              <img
                  data-v-4a829784=""
                  src="/media/icons/svg/arrow-right_white.svg"
                  alt=""
                  class="pointer"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="inner-section newsletter">
      <div class="section-container">
        <div class="my-content">
          <form_newsletter_new/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import form_newsletter_new from "././form-newsletter-new";
import VueInstagram from "vue-instagram";

export default {
  name: "gallery.vue",
  components: {
    form_newsletter_new,
    VueInstagram,
  },
  data() {
    return {
      carousel_items: null,
      move: 0,
      active_item: 0,
      windowWidth: window.innerWidth,
      txt: "",
      moveStep: null,
      igToken: null,
    };
  },
  watch: {
    windowWidth(newWidth, oldWidth) {
      this.txt = `it changed to ${newWidth} from ${oldWidth}`;
      // console.log(this.txt);
      if (newWidth > 1200) {
        this.moveStep = 22;
      } else if (newWidth > 576 && newWidth <= 1200) {
        this.moveStep = 48;
      } else if (newWidth <= 576) {
        this.moveStep = 85; // verificare ipad
      }
    },
  },
  mounted() {
    var width = $(window).width();
    if (width > 1200) {
      this.moveStep = 22;
    } else if (width > 576 && width <= 1200) {
      this.moveStep = 48;
    } else if (width <= 576) {
      this.moveStep = 85; // verificare ipad
    }
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.fetchInstaToken();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    fetchPosts() {
      axios({
        method: "get",
        url: "https://graph.instagram.com/me/media",
        params: {
          access_token: this.igToken,
          fields: "id,caption,media_url",
        },
      }).then((res) => {
        this.carousel_items = res.data.data;
      });
    },
    fetchInstaToken() {
      axios({
        method: "get",
        url: window.location.origin + "/ig-token",
      })
          .then((res) => {
            this.igToken = res.data.token;
            this.fetchPosts();
          })
          .catch((err) => {
            console.log(err.response.data.message);
          });
    },
    onResize() {
      this.windowWidth = window.innerWidth;
      this.move = 0;
      this.active_item = 0;
    },
    prev: function () {
      if (this.active_item === 0) {
        this.active_item = this.carousel_items.length - 1;
        this.move = this.moveStep * (this.carousel_items.length - 1);
      } else {
        this.active_item -= 1;
        this.move -= this.moveStep;
      }
      // console.log(this.move);
    },
    next: function () {
      if (this.active_item === this.carousel_items.length - 1) {
        this.move = 0;
        this.active_item = 0;
      } else {
        this.move += this.moveStep;
        this.active_item += 1;
      }
      // console.log(this.move);
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
  font-size: 1em;
  @media (min-width: 1921px){
    font-size: var(--font-size-large);
  }
 padding-top: 35px;
  .my-content {
    .titolo.desktop, .titolo.mobile {
      color: #fff;
      font-size: 1.75em;
      margin-bottom: 0.5714em;
    }

    h1,
    span {
      color: #fff;
    }

    .container {
      width: 95%;
      max-width: 100%;
    }
  }

  .inner-section {
    width: 100vw;

    &.gallery {
      padding: 100px 0;
      background-color: #25252a;
      // height: 65vh;
      .my-controls {
        display: flex;
        span {
          margin: 0 10px;
        }

        .my-prev {
          margin-left: 20px;
        }
      }

      .my-slide {
        width: fit-content;
        //margin-left: -1vw;
        transition: all 0.5s ease-in-out 0s;

        .external {
          width: 84vw;
          margin: 0 1vw;

          .item {
            position: relative;
            width: 100%;
            padding-top: 100%;
            display: inline-block;
            background-size: contain;
            background-color: #000;

            img {
              height: 100%;
              width: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }

    &.newsletter {
      background-color: #0e0e0e;
      margin-top: auto;
    }
  }
   .my-controls.mobile {
    display: none!important;
  }
  .titolo.mobile {
    display: none;
  }
}

@media (min-width: 576px) {
  .section .inner-section.gallery {

    .my-slide .external {
      width: 46vw;
    }
  }
}

@media (min-width: 992px) {
  .section .inner-section.newsletter {
    //height: 35vh;
  }
}

@media (min-width: 1200px) {
  .section .inner-section.gallery {
    padding: unset;
    padding-bottom: 50px;
    height: 48vh;

    .my-slide .external {
      width: 15vw;
    }
  }
  .section .inner-section.gallery .my-controls {
    width: 82vw;
  }
}

@media (max-width: 576px) {
  .container, .content, .section-container, .section.std {
    height: 100% !important;
  }
  .container {
    overflow-x: scroll;
    position: relative;
    padding: 50px 0;

    &::-webkit-scrollbar {
      display: none;
    }

    .titolo.desktop {
      display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .my-controls.desktop {
   display: none!important;

    //display: none !important;
  }
  .section .titolo.mobile {
    display: block!important;
  }
  .section .inner-section.gallery .my-controls.mobile {
    display: flex!important;
  }
}

@media (min-width: 1921px) {
  .section .inner-section.gallery {
    .my-slide .external {
      width: 20vw;
    }
  }
  .section.std {
    padding-top: 80px;
  }
.section.std.gallery {
  margin-top: 0;
}
}
@media (min-width: 2000px) and (min-height: 800px) {
  .section .inner-section.gallery {
    .my-slide .external {
      width: 15vw;
    }
  }
}
</style>
